











import { PropType } from 'vue';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';

import { IInventoryAdvancePayment } from '@/models';

import InventoryAdvancePaymentCancelButton from '../common/InventoryAdvancePaymentCancelButton.vue';

export default mixins(authMixin).extend({
  name: 'PaymentRequsitionClearedStateCardActions',

  components: {
    InventoryAdvancePaymentCancelButton
  },

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>
    }
  }
});
